import { ReactElement, useId } from 'react'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material'

type UnpublishRequiredDialogProps = {
  open: boolean
  message: string
  onConfirm: () => void
  onCancel: () => void
  isLoading: boolean
}

export default function UnpublishRequiredDialog({
  open,
  message,
  onConfirm,
  onCancel,
  isLoading,
}: UnpublishRequiredDialogProps): ReactElement {
  let id = useId()
  let titleId = `${id}-title`
  let descId = `${id}-desc`

  return (
    <Dialog
      open={open}
      onClose={isLoading ? undefined : onCancel}
      fullWidth
      maxWidth="xs"
      aria-labelledby={titleId}
      aria-describedby={descId}
    >
      <DialogTitle id={titleId}>Unpublish Required</DialogTitle>
      <DialogContent>
        <DialogContentText id={descId}>
          {message} The course will be unpublished before this action is
          completed.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={isLoading}>
          Cancel
        </Button>
        <Button
          color="warning"
          variant="contained"
          onClick={onConfirm}
          disabled={isLoading}
          startIcon={
            isLoading ? <CircularProgress size={14} color="inherit" /> : null
          }
        >
          {isLoading ? 'Unpublishing...' : 'Unpublish & Continue'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
